/**
 * Legacy: Cookies
 *
 * Used by: template-parts/ccpa/change_your_preferences.php
 * Used by: template-parts/ccpa/change_your_preferences_agent.php
 *
 * Note: There used to be funcs related directly to cookies here (get/set),
 * before they were replaced with u-cookies:
 *   src\assets\js-webpack\common\utility\u-cookies.js
 *
 * @module legacy/LCookies
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';
import { UCookies } from '../common/utility/u-cookies';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	dismissBtnClick();
	trackingSwitch();
}

/**
 * Dismiss button click
 *
 * @todo: This doesn't seem to be used by anything
 *
 * @return  {void}
 */
function dismissBtnClick()
{
	$(document).on('click', '.cc_btn_accept_all', function( event ) {
		event.preventDefault();
		$('.cc_banner-wrapper ').css('display', 'none');
	});
}


/**
 * CCPA preference toggle
 *
 * @todo: Use `isGPCPrivacyControlEnabled` from u-cookies.js (UCookies.isGPCPrivacyControlEnabled)
 *
 * @see template-parts/ccpa/change_your_preferences.php
 * @link https://www.on24.com/compliance/?cp=change_your_preferences
 *
 * @return  {void}
 */
function trackingSwitch() {
	var myCookie = getCookie("ccpa_stop_tacking");

	// Bool check because `null` and `undefined` are possible values
	var isGPCPrivacyControlEnabled = ( window.navigator.globalPrivacyControl ) ? true : false;

	if (myCookie == null && !isGPCPrivacyControlEnabled) {
		// Cookie doesn't exist
		// Therefore the checkbox should be unchecked (which sets it to "ON"/green)
		$('.cookie_pref input[type=checkbox]').attr('checked', false);
	} else {
		// Cookie DOES exist
		// Therefore the checkbox should be CHECKED (which sets it to "OFF"/red)
		$('.cookie_pref input[type=checkbox]').attr('checked', true);
	}
}




// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
